// Evaluation-period state for agencies that signed up with an agency
// evaluation code (seats live on the agency row, not in subscriptions).
// Seats only count while the evaluation is unexpired — mirrors the agency
// dashboard's read-time enforcement.
export const getEvaluation = (agency: {
  trial_seats: number | null;
  trial_expires_at: string | null;
}) => {
  const seats = agency.trial_seats || 0;
  if (!seats || !agency.trial_expires_at) return null;
  const expiresAt = new Date(agency.trial_expires_at);
  return { seats, expiresAt, active: expiresAt > new Date() };
};
